import React from 'react'

const OurTeam = () => {
    return (
        <div>
            <h1 className='font-bold text-3xl my-5 text-primary-base'>Our Team</h1>
            <hr className="my-4" />
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit enim, commodi totam ut aliquam eaque delectus molestiae possimus. Tenetur officiis reiciendis numquam quos omnis dolorum porro nostrum dolorem, quod voluptatem?</p>

            <div className="grid grid-cols-3 gap-8 my-12">
                <div className="h-52 w-full mb-12">
                    <img src="https://images.unsplash.com/photo-1507591064344-4c6ce005b128?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" alt="" className='overflow-hidden w-full h-full object-cover' />
                    <h1 className="mt-2 text-xl font-semibold">
                        Aayush Tamang
                    </h1>
                    <p className='text-gray-600 mt-1'>Trekking specialist</p>
                </div>

                <div className="h-52 w-full mb-12">
                    <img src="https://images.unsplash.com/photo-1507591064344-4c6ce005b128?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" alt="" className='overflow-hidden w-full h-full object-cover' />
                    <h1 className="mt-2 text-xl font-semibold">
                        Aayush Tamang
                    </h1>
                    <p className='text-gray-600 mt-1'>Trekking specialist</p>
                </div>

                <div className="h-52 w-full mb-12">
                    <img src="https://images.unsplash.com/photo-1507591064344-4c6ce005b128?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" alt="" className='overflow-hidden w-full h-full object-cover' />
                    <h1 className="mt-2 text-xl font-semibold">
                        Aayush Tamang
                    </h1>
                    <p className='text-gray-600 mt-1'>Trekking specialist</p>
                </div>

                <div className="h-52 w-full mb-12">
                    <img src="https://images.unsplash.com/photo-1507591064344-4c6ce005b128?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" alt="" className='overflow-hidden w-full h-full object-cover' />
                    <h1 className="mt-2 text-xl font-semibold">
                        Aayush Tamang
                    </h1>
                    <p className='text-gray-600 mt-1'>Trekking specialist</p>
                </div>

                <div className="h-52 w-full mb-12">
                    <img src="https://images.unsplash.com/photo-1507591064344-4c6ce005b128?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" alt="" className='overflow-hidden w-full h-full object-cover' />
                    <h1 className="mt-2 text-xl font-semibold">
                        Aayush Tamang
                    </h1>
                    <p className='text-gray-600 mt-1'>Trekking specialist</p>
                </div>
            </div>
        </div>
    )
}

export default OurTeam